<template>
  <div>
    <el-dialog
      v-el-drag-dialog
      :visible="visible"
      :title="$t('CargoMsg.Cargo_PlatformCertifiedPartner')"
      width="900px"
      class="make-invoice-adjust-balance-dialog"
      :close-on-click-modal="false"
      :show-close="true"
      @close="cancel"
    >
      <div>
        <div class="form-row" style="flex-direction:row;max-width: 920px">
          <el-form
            label-width="100px"
            label-position="left"
          >
            <div class="form-row" style="display:flex;flex-direction:row;">
              <el-form
                label-width="100px"
                label-position="left"
                style="margin-right:10px"
              >
                <el-row :span="8">
                  <el-col :span="8">
                    <el-form-item
                      :label="$t('SeaExport.CustomerName')"
                      prop="customerName"
                    >
                      <el-input v-model="filter.customerName" no="customerName" style="width:200px" />
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item
                      label=""
                    />
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="" />
                  </el-col>
                </el-row>
              </el-form>
              <el-button no="queryPageHandler" type="primary" style="height: 30px" @click="queryPageHandler">{{
                $t('CargoMsg.Cargo_Query')
              }}
              </el-button>
            </div>
            <hr>
            <div class="form-row" style="display:flex;flex-direction:row;">
              <el-form
                label-width="100px"
                label-position="left"
                style="margin-right:10px"
              >
                <el-col>
                  <el-row :span="8">
                    <el-form-item
                      :label="$t('SeaExport.BranchCMP')"
                      prop="branchId"
                    >
                      <cargo-advance-select
                        no="pushBranchId"
                        :select-type="selectTypeNames.basic_data_Office"
                        filterable
                        :clearable="false"
                        :callback-params="{key:'pushBranchId'}"
                        callback-method-type="value"
                        style="width: 200px;"
                        :default-value="examineData.pushBranchId"
                        @parentCallBack="selectCargoItem"
                      />
                    </el-form-item>
                  </el-row>
                </el-col>
              </el-form>
            </div>
            <div class="app-main-inner-row" style="padding: 0; justify-content: flex-start;">
              <cargo-ag-grid
                ref="applyList"
                :grid-options="options"
                :column-defs="column"
                :row-data="rowData"
                style="width: 100%;min-width: 180px;height: 400px"
                @gridReady="params=>{gridApi=params.api}"
              />
            </div>
            <div class="pagination-wrapper">
              <cargo-pagination
                config-module="20211214"
                :page.sync="filter.pageNum"
                :limit.sync="filter.pageSize"
                :total="filter.total"
                @pagination="queryPageHandler()"
              />
            </div>
          </el-form>
        </div>
        <div class="spacing" />
        <div class="triggers" align="right">
          <el-button no="cancel" type="primary" @click="cancel">
            {{ $t('common.btn.cancel') }}
          </el-button>
          <el-button no="confirm" type="primary" @click="sendHandler">
            {{ $t('common.btn.confirm') }}
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { wTQueryPageHandler, wTSendHandler } from '@/api/company'
import { getLoading } from '@/utils/utilBaseElement'
import ColumnUtils from '@/utils/ColumnUtils'
import { getToken } from '@/utils/auth'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'WTApplicationListWindow',
  components: { CargoAdvanceSelect },
  props: {
    visible: { type: Boolean, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      loading: false,
      gridApi: null,
      selectedDataList: [],
      selectedNum: 0,
      nowCheckAll: false,
      wtPageUrl: '',
      options: {
        rowSelection: 'multiple',
        suppressCellSelection: true, // 如果为true，则不能选择单元格。这意味着当您单击它们时，单元格不会获得键盘焦点。
        suppressRowClickSelection: true, // 如果为true， 则单击行时不会发生行选择。当您想要专门选择复选框时使用。
        // 行勾选事件
        onRowSelected: this.onRowSelected,
        onSelectionChanged: this.onSelectionChanged,
        defaultColDef: {
          resizable: true
        }
      },
      filter: {
        customerName: null,
        pageNum: 20,
        pageSize: 0,
        total: 0
      },
      examineData: {
        pushBranchId: this.$store.getters.currentOfficeId,
        pushBranchCode: null,
        customerName: null,
        branchId: null,
        companyList: []
      },
      rowData: [],
      column: [
        {
          headerName: '', width: 60,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true,
          checkboxSelection: function(param) {
            return !param.data.nowHave
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_ChineseNamed'), colId: 'companyName', field: 'companyName', width: 200
        },
        {
          headerName: this.$t('CargoMsg.Cargo_EnglishNamed'), colId: 'companyNameEn', field: 'companyNameEn', width: 200
        },
        {
          headerName: this.$t('Partners.alreadyAPartner'), colId: 'nowHave', field: 'nowHave', width: 200,
          valueFormatter: params => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }
      ]
    }
  },
  created() {
    cache.load(cacheName.USER, cacheName.CONFIG)
    this.wtPageUrl = cache.config.get('wtPagePostUrl')
  },
  methods: {
    cancel() {
      this.rowData = []
      this.$emit('visibleHandler')
    },
    selectCargoItem(item) {
      this.examineData.pushBranchId = item.value
    },
    // 发送沃联申请信息
    async sendHandler() {
      if (!this.examineData.pushBranchId) {
        this.$message.warning('请选择分公司!')
        return
      }
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('Partners.selectAPartner'))
        return
      }
      this.loading = getLoading()
      this.examineData.pushBranchCode = ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Office, 'officeId', this.examineData.pushBranchId, 'code')
      this.examineData.companyList = this.selectedDataList
      this.examineData.branchId = this.$store.getters.currentOfficeId
      this.examineData.nowCheckAll = this.nowCheckAll
      if (this.examineData.nowCheckAll) {
        this.examineData.customerName = this.filter.customerName
        this.examineData.pageNum = 1
        this.examineData.pageSize = 10000
      }
      await wTSendHandler(this.examineData).then(res => {
        if (res.data) {
          this.$message.success(this.$t('Partners.applicationSentSuccessfully'))
          const url = this.wtPageUrl + '#/customerEnterpriseApply?key=' + res.data + '&sessionId=' + getToken()
          console.log('openUrl:', url)
          window.open(url)
        }
      }).finally(() => {
        this.cancel()
        this.loading.close()
      })
    },
    async queryPageHandler() {
      this.loading = getLoading()
      this.filter.branchId = this.$store.getters.currentOfficeId
      await wTQueryPageHandler(this.filter).then(res => {
        this.rowData = res.data.list
        this.filter.pageNum = res.data.pageNum
        this.filter.pageSize = res.data.pageSize
        this.filter.total = Number(res.data.total)
        this.selectedDataList = []
        this.selectedNum = 0
        this.nowCheckAll = false
        this.gridApi.clearFocusedCell()
      }).finally(() => {
        this.loading.close()
      })
    },
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedNum += 1
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
    },
    onSelectionChanged(event) {
      // 校验全选事件 此时点击确认时，会根据查询条件推送全部数据
      if (this.selectedNum > 1) {
        this.nowCheckAll = true
      } else {
        this.nowCheckAll = false
      }
      this.selectedNum = 0
    }
  }
}
</script>
<style scoped>

ul li {
  list-style: none;
  font-size: 13px;
  color: #909399;
}

.spacing {
  padding-top: 20px;
}
</style>

